import { BaseTable } from '@sede-enterprise/shell-ds-react-framework';
import styled from 'styled-components';
import { IKpiModal } from '../../types/types';
import { NET_ABSOLUTE_EMISSIONS, OPERATED_SCOPE, EQUITY_SCOPE } from '../../api/constants';
import { setColorByValueForKpiCard } from '../AllDeals/DealDetails/DealDetailFunctions';
import { one } from '../../constants';
import { useEffect } from 'react';

const Container = styled.div`
  overflow: scroll;
  margin-top: 10px;
`;

export const KpiTable = (props: {
  cols: Array<string | number>;
  stepThreeNciData: IKpiModal[];
  isTSProducts?: boolean;
}) => {
  const { cols, stepThreeNciData, isTSProducts } = props;
  type CellInfo = {
    column: { id: string };
    getValue: () => unknown;
    row: { original: Record<string, unknown> };
  };

  const allCols = cols.map((val) => {
    return {
      accessorKey: val.toString(),
      header: val.toString(),
      cell: (info: CellInfo) => {
        // Only apply disabled style for KPI column
        if (info.column.id === 'KPI' && isTSProducts) {
          const kpi = String(info.getValue() ?? '');
          // Gray out operated/equity scope rows for T&S Products
          if (kpi === OPERATED_SCOPE || kpi === EQUITY_SCOPE) {
            return <span style={{ color: '#bdbdbd' }}>{kpi}</span>;
          }
          // Display Net Absolute Emissions in KTPA for T&S Products visually,
          // but keep the canonical KPI key unchanged in data.
          if (kpi === NET_ABSOLUTE_EMISSIONS) {
            return <>{NET_ABSOLUTE_EMISSIONS.replace('(MTPA)', '(KTPA)')}</>;
          }
        }
        const value = info.getValue();
        return value as unknown as string;
      },
    };
  });
  const targetIndex = stepThreeNciData.length - one;

  useEffect(() => {
    const timeout = setTimeout(() => {
      setColorByValueForKpiCard(targetIndex, 'kpi-table');
    }, 0); // Delay of 0ms ensures it runs after the DOM is updated

    return () => clearTimeout(timeout); // Cleanup timeout
  }, [stepThreeNciData]);

  // No rowStyle helper needed; per-cell rendering controls disabled styling.

  return (
    <Container>
      <BaseTable
        className='kpi-table'
        style={{ width: '100%' }}
        size='small'
        noFooter
        maxHeight={1000}
        columns={allCols}
        data={stepThreeNciData as unknown as Record<string, unknown>[]}
      />
    </Container>
  );
};
